interface WithCargoWeight {
  cargoWeight?: number;
}

export const hasSenderReceiverCountries = (state: WithCargoWeight): boolean => {
  return Boolean(state.cargoWeight && state.cargoWeight > 0);
};
